/**
 * Drip Builder editor — /marketing-hub/drip-builder
 *
 * The drip browse surface (starter kits + the tenant's drip flows) now lives in
 * the Marketing Hub "Drip Builder" tab (/marketing?tab=drip-builder). This route
 * is the editor itself: opened from a starter kit ("Use This Template") or by
 * clicking an existing drip flow.
 *
 * URL params:
 *   ?dripGroupId=<id>&edit=true  → pre-loads an existing drip for editing
 *   (no params)                  → starts a new, blank drip
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import TopBar from '../../components/TopBar.jsx';
import DripBuilderTab from './tabs/DripBuilderTab.jsx';

export default function DripBuilder() {
  return (
    <div className="space-y-4 min-h-0" data-testid="drip-builder-page">
      <Link to="/marketing?tab=drip-builder" className="inline-flex items-center gap-1.5 text-sm text-white/60 hover:text-white transition" data-testid="drip-builder-back">
        <ArrowLeft className="w-4 h-4" /> Back to Drips
      </Link>
      <TopBar title="Drip Builder" subtitle="Build and edit your drip cadence" />
      <DripBuilderTab />
    </div>
  );
}
